import { structureTemplates } from './structures';
/**
 * In the order the categories are declared, so the grid reads the same way every time.
 *
 * Not sorted by name: a catalogue that reshuffles itself when a template is renamed makes
 * "the third one along" stop meaning anything to somebody who uses it every week.
 */
export const BUNDLED_TEMPLATES = structureTemplates;
//# sourceMappingURL=index.js.map